export default __webpack_public_path__ + "static/media/culture-little-desktop.72b79fd4.png";